<template>
  <div>

    <div class="form-group d-flex flex-column">
      <label class="custom-label">{{ this.labelDesc }}</label>
      <img class="w-100 mb-2" v-if="value && value != 'none'" :src="value" style="max-height: 154px; object-fit: contain;
        background-color: #c2c2c2; ">
      <div class="form d-flex">
        <button class="btn btn-primary btn-small flex-fill" @click="getImages">{{ $t('ct-change-image') }}</button>
        <button v-show="canRemove" v-on:click="removeImage" class="btn btn-danger btn-small ml-1">
          <font-awesome-icon
            size="xs"
            :icon="['far', 'trash-alt']"
            class="font-awesome-icon"
          />
        </button>
      </div>
    </div>

    <div class="form-group" v-if="canExternal">
      <label class="custom-label">{{ $t('ct-resource-external-image') }}</label>
      <div class="input-group">
        <input type="text" class="custom-input form-control " v-model="valueInput" placeholder="https://someimageurl.com.br">
        <div class="input-group-append">
          <button class="btn btn-primary btn-small" type="button" @click="applyExternalImage">{{ $t('ct-resource-apply') }}
          </button>
        </div>
      </div>
    </div>

    <div class="form-group hidden-resource" v-show="value != 'none' && showOptions">
      <div class="form">

        <!-- origin -->
        <div class="radio" ref="origin"  style="padding-top: 30px">
          {{$t('ct-bg-config-origin')}}:
          <div class="bg-config-group">
            <label
              v-for="(option, index) in optionsOrigin" :key="index"
              v-tooltip="{content: option.tooltip,  class: 'tooltip-custom'}"
              :style="{backgroundImage: `url(${pathIcons}/origin/${option.icon}.svg)`}">
              <input
                type="radio" v-model="origin"
                :name="nameConfig+canExternal+'origin'"
                :value="option.value"
                @change="changeValue">
              <span></span>
            </label>
          </div>
        </div>

        <!-- position -->
        <div class="radio" ref="position" style="padding-top: 30px">
          {{$t('ct-gdpr-position')}}:
          <div class="bg-config-group">
            <label
              v-for="(option, index) in optionsPosition" :key="index"
              :style="{backgroundImage: `url(${pathIcons}/position/${option.icon}.svg)`}">
              <input
                type="radio" v-model="position"
                :name="nameConfig+canExternal+'position'"
                :value="option.value"
                @change="changeValue">
              <span></span>
            </label>
          </div>
        </div>

        <!-- repeat -->
        <div class="radio" ref="repeat" style="padding-top: 30px">
          {{$t('ct-bg-config-repeat')}}: {{ repeat }}
          <div class="bg-config-group">
            <label
              v-for="(option, index) in optionsRepeat" :key="index"
              v-tooltip="{content: option.tooltip,  class: 'tooltip-custom'}"
              :style="{backgroundImage: `url(${pathIcons}/repeat/${option.icon}.svg)`}">
              <input
                type="radio" v-model="repeat"
                :name="nameConfig+canExternal+'repeat'"
                :value="option.value"
                @change="changeValue">
              <span></span>
            </label>
          </div>
        </div>

        <!-- size -->
        <div class="radio" ref="size" style="padding-top: 30px">
          {{$t('ct-bg-config-size')}}:
          <div class="bg-config-group">
            <label
              v-for="(option, index) in optionsSize" :key="index"
              v-tooltip="{content: option.tooltip,  class: 'tooltip-custom'}"
              :style="{backgroundImage: `url(${pathIcons}/size/${option.icon}.svg)`}">
              <input
                type="radio" v-model="size"
                :name="nameConfig+canExternal+'size'"
                :value="option.value"
                @change="changeValue">
              <span></span>
            </label>
          </div>
        </div>

        <!-- attachment -->
        <div class="radio" ref="attachment" v-show="activeAttachment" style="padding-top: 30px">
          {{$t('ct-bg-config-repeat-attachment-title')}}:
          <label v-for="(option, index) in optionsAttachment" :key="index">
            <input
              type="radio" v-model="attachment"
              :name="nameConfig+canExternal+'attachment'"
              :value="option.value"
              @change="changeValue">
            {{ option.label}}
          </label>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {getImages} from '../../../js/services/editor/externalImage';
  import {SweetModal, SweetModalTab} from 'sweet-modal-vue';
  import FileUpload from 'v-file-upload';
  import FileManager from './../../general/FilesManager/FileManager'

  export default {
    name: 'ImageComponent',
    props:{
      activeAttachment: {
        type: Boolean,
        default: true
      },
      nameConfig: {
        type: String,
        default: ''
      },
    },
    components: {
      SweetModal,
      SweetModalTab,
      FileUpload,
      FileManager
    },
    data() {
      return {
        id: '',
        images: [],
        directories: [],
        element: null,
        imageSelected: null,
        value: '',
        valueInput: '',
        canRemove: false,
        canExternal: false,
        showOptions: true,
        labelDesc: 'opa',
        callback: null,
        origin: null,
        repeat: 'border-box',
        size: null,
        position: null,
        attachment: null,
        headers: {
          authorization: 'Bearer ' + localStorage.getItem('token')
        },
        pathIcons: '/static/images/background-config',
        optionsPosition: [
          { value: 'left top'     , icon: 'left-top'},
          { value: 'center top'   , icon: 'center-top'},
          { value: 'right top'    , icon: 'right-top'},
          { value: 'left center'  , icon: 'left-center'},
          { value: 'center'       , icon: 'center'},
          { value: 'right center' , icon: 'right-center'},
          { value: 'left bottom'  , icon: 'left-bottom'},
          { value: 'center bottom', icon: 'center-bottom'},
          { value: 'right bottom' , icon: 'right-bottom'},
        ],
        optionsOrigin: [
          { value: 'border-box'   , icon: 'border-box'    , tooltip: this.$t('ct-bg-config-origin-border')},
          { value: 'content-box'  , icon: 'content-box'   , tooltip: this.$t('ct-bg-config-origin-content')},
          { value: 'padding-box'  , icon: 'content-box'   , tooltip: this.$t('ct-bg-config-origin-padding')},
        ],
        optionsRepeat: [
          { value: 'no-repeat', icon: 'no-repeat' , tooltip: this.$t('ct-bg-config-repeat-no-repeat')},
          { value: 'repeat'   , icon: 'repeat'    , tooltip: this.$t('ct-bg-config-repeat-repeat')},
          { value: 'repeat-x' , icon: 'repeat-x'  , tooltip: this.$t('ct-bg-config-repeat-repeat-x')},
          { value: 'repeat-y' , icon: 'repeat-y'  , tooltip: this.$t('ct-bg-config-repeat-repeat-y')},
          { value: 'space'    , icon: 'space'     , tooltip: this.$t('ct-bg-config-repeat-space')},
          { value: 'round'    , icon: 'round'     , tooltip: this.$t('ct-bg-config-repeat-round')}
        ],
        optionsSize: [
          { value: 'auto'     , icon: 'auto'    , tooltip: this.$t('ct-bg-config-size-auto')},
          { value: '50%'      , icon: '50'      , tooltip: this.$t('ct-bg-config-size-50')},
          { value: '100% 100%', icon: '100-100' , tooltip: this.$t('ct-bg-config-size-100')},
          { value: 'cover'    , icon: 'cover'   , tooltip: this.$t('ct-bg-config-size-cover')},
          { value: 'contain'  , icon: 'contain' , tooltip: this.$t('ct-bg-config-size-contain')},
        ],
        optionsAttachment: [
          { value: 'scroll'   , label: this.$t('ct-bg-config-repeat-attachment-scroll')},
          { value: 'fixed'    , label: this.$t('ct-bg-config-repeat-attachment-fixed')}
        ]
      };
    },
    methods: {
      applyExternalImage() {
        this.value = this.valueInput;
        let response = {
          'type' : 'setImage',
          'src' : this.value
        }
        this.callback(response);
      },

      removeImage() {
        this.value = 'none';
        let response = {
          'type' : 'removeImage'
        }
        this.callback(response);
      },

      save(image) {
        this.imageSelected = image;

        if (typeof this.callback === 'function') {
          this.value = this.imageSelected;
          let response = {
            'type' : 'setImage',
            'src' : this.value
          }
          this.callback(response);
        }
        this.close();
      },

      close() {
        let values = {
          action: 'close',
          type: 'Images',
          save: this.save,
          close: this.close
        };
        this.$root.$emit('fileMananger', values);
      },

      selectImage(image) {
        let elements = document.getElementsByClassName('focused');
        [].forEach.call(elements, function (el) {
          el.classList.remove('focused');
        });

        this.imageSelected = image;
        document.getElementById(image.id).classList.add('focused');
      },

      getImages() {

        let values = {
          action: 'open',
          type: 'Images',
          save: this.save,
          close: this.close
        };
        this.$root.$emit('fileMananger', values);
      },
      changeTab(id) {
        var navtabActive = this.$refs.modalImages.querySelectorAll(
          '.nav-link.active, .tab-pane.active'
        );
        Object.keys(navtabActive).forEach(index => {
          navtabActive[index].classList.remove('active');
          navtabActive[index].classList.remove('show');
        });

        if (this.$refs['nav-tab-' + id].classList) {
          this.$refs['nav-tab-' + id].classList.add('active');
          this.$refs['nav-tab-' + id].classList.add('show');
        }

        if (this.$refs['nav-' + id].classList) {
          this.$refs['nav-' + id].classList.add('active');
        }
      },
      changeValue() {

        let response = {
          type: 'setConfig',
          position: this.position,
          repeat: this.repeat,
          size: this.size,
          attachment: this.attachment,
          origin: this.origin
        }
        this.callback(response);
      },
      setValues(obj, elem) {
        this.id = typeof obj.id == "undefined" ? +new Date() : obj.id;
        this.value = obj.defaultValue;
        this.element = elem;
        this.canRemove = obj.canRemove;
        this.canExternal = typeof obj.canExternal == "undefined" ? false : obj.canExternal;
        this.labelDesc = obj.labelDesc ? this.$t(`ct-${obj.labelDesc}`) : this.$t(`ct-image`);

        if (typeof obj.showOptions == 'undefined') {
          this.showOptions = true;
        } else {
          this.showOptions = obj.showOptions;
        }

        this.origin = obj.defaultValueOrigin;
        this.repeat = obj.defaultValueRepeat;
        this.size = obj.defaultValueSize;
        this.position = obj.defaultValuePosition;
        this.attachment = obj.defaultValueAttachment;

        this.callback = obj.callback;

        this.$forceUpdate();

			}

		},
  };
</script>

<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }

  .image-item {
    width: 140px;
    height: 70px;
    display: inline-block;
    cursor: pointer;
    text-align: center;
  }

  .image-item.focused {
    outline: 2px solid blue;
  }

  .image-item img {
    width: 100px;
    height: 50px;
  }

  .image-name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
  }

  .radio {
    display: inline-grid;
    margin-left: 5px;
    width: 100%;
  }

  /******** BG ICONS *******/
  $iconSize: 44px;

  .bg-config-group {
    display: grid;
    grid-template-columns: repeat(3, $iconSize);
    margin: 15px 0 0 0;
    gap: 5px;

    label {
      background-size: $iconSize;
      cursor: pointer;
      display: flex;
      height: $iconSize;
      margin: 0;
      border-radius: 4px;

      &:hover {
        opacity: .8;
      }

      input[type="radio"] {
        display: none;
        &:checked ~ span {
          border: 3px solid #05c1fc;
        }
      }
      span {
        flex: 1;
      }
    }
  }

</style>

<style lang="scss">
  /*.sweet-modal {*/

  /*  .sweet-content {*/
  /*    max-height: 70vh !important;*/
  /*    overflow: auto;*/
  /*    text-align: left;*/
  /*  }*/

  /*  .btn {*/
  /*    cursor: pointer;*/
  /*    margin-left: 5px;*/
  /*  }*/
  /*}*/

  /*.upload-area {*/
  /*  text-align: right;*/
  /*  padding-bottom: 20px;*/
  /*  height: 70px;*/

  /*  .file-upload .input-wrapper {*/
  /*    height: 50px;*/
  /*    width: 15%;*/
  /*    float: right;*/
  /*  }*/

  /*  .file-upload-icon {*/
  /*    display: none !important;*/
  /*  }*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/editor/resource_components/Image.vue